// Master JS for the home page

import BootstrapModal from "bootstrap/js/dist/modal";

import { VideoModal } from "./webcomponents/video-modal.js";

// Register required webcomponents
VideoModal.Register();

// Partner welcome modal, only rendered on the /caringbridge and /mmt routes
const partnerModal = document.getElementById("pg-partner-modal");
if (partnerModal) {
    BootstrapModal.getOrCreateInstance(partnerModal).show();
}
